export default __webpack_public_path__ + "static/media/Leggings of the Faceless Chaos.2142497e.jpg";